import * as Yup from "yup";
import { TransType } from "system/translations/types";

export const createEditValidation = (_t: TransType, params: any) => {
  return Yup.object().shape({
    email: Yup.string().email(_t("invalid")).required(_t("required")),
    comment: Yup.string().notRequired(),
  });
};
